import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { simpleAnalyticsTrack, useAnalytics } from "@cinch-nx/shared-analytics";
import React from "react";
import CookieBanner from "./components/cookie-banner/cookie-banner.component";
import CookiePreferencesModal from "./components/cookie-preferences-modal/cookie-preferences-modal.component";
import styles from "./cookie-consent.module.css";
import { useCookieEditorTime } from "./hooks/cookie-editor-time.hook";
import { useCookiePreferences } from "./hooks/cookie-preferences.hook";
import { SegmentPreferences } from "./models";
import { addEvent } from "./utils";
var CookieConsent = function(param) {
    var _consentManager = param.consentManager, destinations = _consentManager.destinations, preferences = _consentManager.preferences, setPreferences = _consentManager.setPreferences, saveConsent = _consentManager.saveConsent, count = param.count, setLoaded = param.setLoaded, isPreferencesModalOpen = param.isPreferencesModalOpen, setIsPreferencesModalOpen = param.setIsPreferencesModalOpen;
    var ref;
    var segmentPreferences = new SegmentPreferences(destinations, setPreferences);
    var setHasAcceptedCookies = useAnalytics().setHasAcceptedCookies;
    var ref1 = useCookieEditorTime(isPreferencesModalOpen), cookieEditorTime = ref1.cookieEditorTime, startTime = ref1.startTime;
    var ref2 = useCookiePreferences(setLoaded), cookiePreferences = ref2.cookiePreferences, setCookiePreferences = ref2.setCookiePreferences, isCookieConsentSet = ref2.isCookieConsentSet;
    var isStoryBlokEdit = (ref = window.location) === null || ref === void 0 ? void 0 : ref.href.includes("_storyblok");
    var shouldShowCookieBanner = !isCookieConsentSet && !isStoryBlokEdit;
    var isPrivacyPage = (window === null || window === void 0 ? void 0 : window.location.pathname) === "/policies/privacy";
    var handleSaveCookiePreferencesFromModal = function(updatedCookiePreferences) {
        // Save Segment preferences
        saveConsent();
        setIsPreferencesModalOpen(false);
        setCookiePreferences(updatedCookiePreferences);
        addEvent({
            startTime: startTime,
            elementType: "modal",
            count: count,
            cookieEditorTime: cookieEditorTime,
            settingsType: isPrivacyPage ? "edited" : "initial",
            cookiePreferences: updatedCookiePreferences
        });
        window.location.reload();
    };
    // Fired when Accept additional cookies is clicked in nested banner
    var handleSaveCookiePreferencesFromBanner = function(acceptAll) {
        // Do we need somewhere else to do this sort of segment related logic
        destinations.forEach(function(destination) {
            setPreferences(_define_property({}, destination.id, acceptAll));
        });
        saveConsent(acceptAll ? true : undefined);
        var updatedCookiePreferences = {
            advertising: acceptAll,
            analytics: acceptAll,
            functional: acceptAll
        };
        setCookiePreferences(updatedCookiePreferences);
        addEvent({
            startTime: startTime,
            elementType: "banner",
            count: count,
            cookieEditorTime: cookieEditorTime,
            settingsType: "initial",
            cookiePreferences: updatedCookiePreferences
        });
        setHasAcceptedCookies(true);
        simpleAnalyticsTrack(acceptAll ? "cookie_banner_accept" : "cookie_banner_reject");
        window.location.reload();
    };
    var openPreferencesModalAndTrack = function() {
        simpleAnalyticsTrack("cookie_banner_customise");
        setIsPreferencesModalOpen(true);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            shouldShowCookieBanner && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    !isPrivacyPage ? /*#__PURE__*/ _jsx("div", {
                        className: styles.overlay,
                        "data-testid": "overlay"
                    }) : null,
                    /*#__PURE__*/ _jsx(CookieBanner, {
                        handleManageSettingsButtonClick: openPreferencesModalAndTrack,
                        handleAcceptCookiesButtonClick: handleSaveCookiePreferencesFromBanner,
                        hydrated: true,
                        isPreferencesModalOpen: isPreferencesModalOpen
                    })
                ]
            }),
            isPreferencesModalOpen && /*#__PURE__*/ _jsx(CookiePreferencesModal, {
                existingCookiePreferences: cookiePreferences,
                onClose: function() {
                    return setIsPreferencesModalOpen(false);
                },
                destinationPreferences: preferences,
                onSaveCookiePreferences: function(updatedCookiePreferences) {
                    return handleSaveCookiePreferencesFromModal(updatedCookiePreferences);
                },
                segmentPreferences: segmentPreferences
            })
        ]
    });
};
export default CookieConsent;
